import { atom } from "jotai";

export const authModalEmailFieldAtom = atom("");
